<div class="d-flex w-100">
  <div class="col-12 col-md-8 col-lg-7 left-container">
    <h3 class="m-0">{{ "Create an Account" | translate }}</h3>
    <p>{{ "Sign up now and unlock exclusive access!" | translate }}</p>
    <br />
    <p-selectButton
      [options]="accountOptions"
      [(ngModel)]="accountType"
      optionLabel="label"
      optionValue="value"
    />
    <br />

    <div class="mt-3" *ngIf="accountType === 'company'">
      <label>{{ "Company Name" | translate }} </label>
      <div class="input-container mt-1">
        <i class="bi bi-buildings fs-4 left-icon"></i>
        <input
          type="text"
          placeholder="{{ 'Enter your company name' | translate }}"
        />
      </div>
    </div>
    <div class="mt-3">
      <label>{{ "Full Name" | translate }}</label>
      <div class="input-container mt-1">
        <i class="bi bi-person fs-3 left-icon"></i>
        <input
          type="text"
          placeholder="{{ 'Enter your name' | translate }}"
          [(ngModel)]="name"
        />
      </div>
      <div class="mt-3">
        <label>{{ "Phone Number" | translate }}</label>
        <div class="input-container mt-1">
          <i class="bi bi-telephone left-icon"></i>
          <input
            type="text"
            placeholder="{{ 'Enter your phone number' | translate }}"
            [(ngModel)]="phoneNumber"
          />
        </div>
      </div>
    </div>
    <div class="mt-3">
      <label>{{ "Email" | translate }}</label>
      <div class="input-container mt-1">
        <i class="bi bi-envelope left-icon"></i>
        <input
          type="text"
          placeholder="{{ 'Enter your email' | translate }}"
          [(ngModel)]="email"
        />
      </div>
    </div>
    <div class="mt-3">
      <label>{{ "Password" | translate }}</label>
      <div class="input-container mt-1">
        <i class="bi bi-lock left-icon"></i>

        <input
          type="{{ showPassword ? 'text' : 'password' }}"
          placeholder="{{ 'Enter your password' | translate }}"
          [(ngModel)]="password"
        />

        <i
          class=" eye-icon {{ showPassword ? 'bi-eye-slash' : 'bi bi-eye ' }}"
          (click)="toggleShowPassword()"
        ></i>
      </div>
    </div>
    <div class="mt-3">
      <label>{{ "Confirm Password" | translate }}</label>
      <div class="input-container mt-1">
        <i class="bi bi-lock left-icon"></i>

        <input
          type="{{ showConfirmPassword ? 'text' : 'password' }}"
          placeholder="{{ 'Renter your password' | translate }}"
          [(ngModel)]="confirmPassword"
        />

        <i
          class=" eye-icon {{
            showConfirmPassword ? 'bi-eye-slash' : 'bi bi-eye '
          }}"
          (click)="toggleConfirmShowPassword()"
        ></i>
      </div>
    </div>

    <button (click)="signUp()" class="w-100 gradient-button">
      {{ "Register" | translate }}
    </button>

    <div class="or-divider mt-4">
      <div class="line"></div>
      <label>{{ "Or" | translate }}</label>
      <div class="line"></div>
    </div>
    <div class="d-flex justify-content-between social mt-4">
      <button (click)="registerWithGoogle()">
        <img width="8%" src="../../../../assets/img/google.svg" />
        {{ "Signup with Google" | translate }}
      </button>
      <button (click)="registerWithLinkedIn()">
        <img width="8%" src="../../../../assets/img/linkedIn-auth.svg" />
        {{ "Signup with LinkedIn" | translate }}
      </button>
    </div>
    <div class="text-center mt-4">
      {{ "Login with another account?" | translate }}
      <span class="bold-text" routerLink="/login">{{
        "Login" | translate
      }}</span>
    </div>
  </div>

  <div class="d-none d-md-block col-md-4 col-lg-5 right-container">
    <img width="20%" src="../../../../assets/img/logo.png" />
    <br />
    <img width="80%" class="mt-3" src="../../../../assets/img/authGroup.svg" />
  </div>
</div>
